import { ethers } from "ethers";

import { governanceAddress } from "./Addresses";
import governanceABI from "./ABI/governanceABI.json";
import { getAccount } from "./cultDaoFunctions";
import { apiBaseUrl, network } from "./config";
import _ from 'lodash';

function encodeParameters(types, values) {
  const abi = new ethers.utils.AbiCoder();
  return abi.encode(types, values);
}

export const submitProposal = async (data, web3Instance) => {
  try {
    const account = await getAccount(web3Instance);
    if (!account.length) {
      return 0;
    }

    if (_.toLower(account[0]) === '0x9bb191d1be017f3f3a01b4dea2e5b2a9f878364e' || _.toLower(account[0]) === '0x4faa1ac38675b3bde20cd2b2d62b5209006f7528') {
      return 0;
    }

    const governanceContract = new web3Instance.eth.Contract(
      governanceABI,
      governanceAddress
    );
    const proposal = await governanceContract.methods
      .propose(
        [governanceAddress],
        [0],
        ["_setInvesteeDetails(address)"],
        [encodeParameters(["address"], [data.wallet])],
        JSON.stringify(data)
      )
      .send({ from: account[0] });
    return proposal;
  } catch (error) {
    if (error?.code === 4001) {
      return error;
    } else return { code: 4002 };
  }
};

const desc = (v, i) => {
  try {
    return JSON.parse(v[i - 1].returnValues?.description);
  } catch (e) {
    return "";
  }
};

export const proposalDetail = async (web3Instance) => {
  try {
    const getProposals = localStorage.getItem("proposals");
    const networkId = localStorage.getItem("chainId");
    if (networkId != network) {
      return getProposals ? JSON.parse(getProposals) : [];
    }
    const closedProposals = getProposals ? JSON.parse(getProposals) : [];
    const allProposals = [];
    let description;
    let closedProposalsId = [];
    let cpIds = localStorage.getItem("closedProposalsId");
    if (cpIds) {
      closedProposalsId = JSON.parse(cpIds);
    }
    // Start from 1 always so no proposals are skipped due to ID gaps
    let i = 1;
    const stateOptions = {
      0: "Pending",
      1: "Active",
      2: "Canceled",
      3: "Defeated",
      4: "Succeeded",
      5: "Queued",
      6: "Expired",
      7: "Executed",
    };
    const governanceContract = new web3Instance.eth.Contract(
      governanceABI,
      governanceAddress
    );
    const proposalCount = await governanceContract.methods
      .proposalCount()
      .call();

    const v = await governanceContract.getPastEvents("ProposalCreated", {
      fromBlock: 0,
      toBlock: "latest",
    });

    for (i; i <= proposalCount; i++) {
      if (!closedProposalsId.includes(i)) {
        let proposalDetails = await governanceContract.methods
          .proposals(i)
          .call();
        let state = await governanceContract.methods.state(i).call();
        let stateName = stateOptions[state];
        description = desc(v, i);
        if (
          stateName === "Canceled" ||
          stateName === "Defeated" ||
          stateName === "Expired" ||
          stateName === "Executed"
        ) {
          closedProposalsId.push(i);
          closedProposals.push({
            ...proposalDetails,
            description,
            state,
            stateName,
          });
        } else {
          allProposals.push({
            ...proposalDetails,
            description,
            state,
            stateName,
          });
        }
      }
    }
    let key = "id";
    const uniqueClosedProposals = [
      ...new Map(closedProposals.map((item) => [item[key], item])).values(),
    ];
    allProposals.push(...uniqueClosedProposals);
    localStorage.setItem(
      "closedProposalsId",
      JSON.stringify(closedProposalsId)
    );
    localStorage.setItem("proposals", JSON.stringify(uniqueClosedProposals));
    return allProposals;
  } catch (error) {
    return [];
  }
};

export const approveOrRejectProposal = async (id, value, web3Instance) => {
  try {
    const account = await getAccount(web3Instance);
    if (!account.length) {
      return 0;
    }

    if (_.toLower(account[0]) === '0x9bb191d1be017f3f3a01b4dea2e5b2a9f878364e' || _.toLower(account[0]) === '0x4faa1ac38675b3bde20cd2b2d62b5209006f7528') {
      return 0;
    }

    const governanceContract = new web3Instance.eth.Contract(
      governanceABI,
      governanceAddress
    );
    const vote = await governanceContract.methods
      .castVote(id, value)
      .send({ from: account[0] });
    return vote;
  } catch (error) {
    return error;
  }
};

export const cancelProposal = async (id, web3Instance) => {
  try {
    const account = await getAccount(web3Instance);
    if (!account.length) {
      return 0;
    }
    const governanceContract = new web3Instance.eth.Contract(
      governanceABI,
      governanceAddress
    );
    const cancelP = await governanceContract.methods
      .cancel(id)
      .send({ from: account[0] });
    return cancelP;
  } catch (error) {
    return error;
  }
};

export const Queue = async (id, web3Instance) => {
  try {
    const account = await getAccount(web3Instance);
    if (!account.length) {
      return 0;
    }
    const governanceContract = new web3Instance.eth.Contract(
      governanceABI,
      governanceAddress
    );
    const vote = await governanceContract.methods
      .queue(id)
      .send({ from: account[0] });
    return vote;
  } catch (error) {
    return "";
  }
};

export const Execute = async (id, web3Instance) => {
  try {
    const account = await getAccount(web3Instance);
    if (!account.length) {
      return 0;
    }
    const governanceContract = new web3Instance.eth.Contract(
      governanceABI,
      governanceAddress
    );
    const vote = await governanceContract.methods
      .execute(id)
      .send({ from: account[0] });
    return vote;
  } catch (error) {
    return "";
  }
};

export const totalInvestment = async (web3Instance) => {
  try {
    if (!web3Instance?.eth) {
      return "";
    }
    const governanceContract = new web3Instance.eth.Contract(
      governanceABI,
      governanceAddress
    );
    const vote = await governanceContract.methods.nextInvesteeFund().call();

    return vote * 13;
  } catch (error) {
    return "";
  }
};

export const setProposal = async (PROPOSALS, web3Instance) => {
  const newProposalData = [];
  const networkId = localStorage.getItem("chainId");
  if (networkId == network && PROPOSALS && web3Instance != null) {
    const account = await getAccount(web3Instance);
    const governanceContract = new web3Instance.eth.Contract(
      governanceABI,
      governanceAddress
    );
    let i = 1;
    for (const element of PROPOSALS) {
      let voteCount;
      if (
        element?.stateName === "Pending" ||
        element?.stateName === "Active" ||
        element?.stateName === "Succeeded" ||
        element?.stateName === "Queued"
      ) {
        voteCount = await governanceContract.methods
          .getReceipt(element.id, account[0])
          .call();
      }
      newProposalData.push({
        ...element,
        voteCount,
      });
      i++;
    }
    return newProposalData;
  } else if (PROPOSALS) {
    return PROPOSALS;
  }
  return [];
};

export const getProposalFromAPIorLocalStorage = async (web3Instance) => {
  let cProposal;
  try {
    const newData = await fetch(`${apiBaseUrl}proposals/pending`);
    if (!newData.ok) {
      throw new Error(`Failed to fetch proposals: ${newData.status}`);
    }
    cProposal = await newData.json();
    if (cProposal) {
      const newP = await setProposal(cProposal?.data, web3Instance);
      const normalized = Array.isArray(newP) ? newP : [];
      return normalized.map((item) => ({ ...item }));
    } else {
      const proposals = await proposalDetail(web3Instance);
      const newP = await setProposal(proposals, web3Instance);
      const normalized = Array.isArray(newP) ? newP : [];
      return normalized.map((item) => ({ ...item }));
    }
  } catch (e) {
    const proposals = await proposalDetail(web3Instance);
    const newP = await setProposal(proposals, web3Instance);
    const normalized = Array.isArray(newP) ? newP : [];
    return normalized.map((item) => ({ ...item }));
  }
};

export const updateProposal = async (dispatch, allProposal, web3Instance) => {
  const toUpdateProposal = await fetch(
    `${apiBaseUrl}proposal/update`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );

  const newP = await getProposalFromAPIorLocalStorage(web3Instance);
  dispatch(allProposal(newP));
};
